import React from 'react';
import { RouteComponentProps } from '@reach/router';
import { AntButton, BlockLoading2 } from '@/components';
import _ from 'lodash';
import { observer } from 'mobx-react-lite';
import { AntDrawer } from '@/components/antd/drawer';
import { defaultAuthDeco } from '@/containers/hoc';
import { IJobStore } from '../utils';
import DemoForm from './form';
import { tryRefresh } from '@/utils';

const FormDrawer: React.FC<RouteComponentProps & {
    defaultStore: IJobStore;
    preRequiredReady: boolean;
}> = ({ defaultStore, preRequiredReady }) => {
    const { actionType, bigFormVisible, mutatingDataLoading } = defaultStore;

    if (!preRequiredReady) {
        return <BlockLoading2 />;
    }

    const popups = (
        <>
            <AntDrawer
                title={actionType === 'create' ? '新建xx' : '修改xx'}
                placement={'right'}
                visible={bigFormVisible}
                onClose={() => {
                    defaultStore.resetAction();
                }}
                bodyStyle={{
                    width: 850,
                    overflow: 'scroll',
                }}
                width={850 + 'px'}
            >
                <div className="standard-drawer-form-wrapper">
                    {mutatingDataLoading ? (
                        <BlockLoading2 />
                    ) : (
                        <DemoForm defaultStore={defaultStore} />
                    )}
                    <div className="fixed-form-btns">
                        <AntButton
                            size="large"
                            type="primary"
                            onClick={async () => {
                                const isSuccess = await defaultStore.dispatchAction();
                                if (isSuccess) {
                                    tryRefresh([defaultStore.tableCode]);
                                }
                            }}
                        >
                            {actionType === 'create' ? '新建' : '修改'}
                        </AntButton>
                        <AntButton
                            size="large"
                            onClick={() => defaultStore.resetAction()}
                        >
                            取消
                        </AntButton>
                    </div>
                </div>
            </AntDrawer>
        </>
    );

    return popups;
};

const FinalFormDrawer = defaultAuthDeco(observer(FormDrawer));
export default FinalFormDrawer;
